/*
 * @Author: jy
 * @说明：财务相关接口地址
 */

// 获取收款记录
export const recordList = '/finance/finance-record/list'
// 获取收款记录详情
export const recordDetail = '/finance/finance-record/one-record'
// 修改收款记录
export const updaterecord = '/finance/finance-record/update-record'
// 销售报表
export const salesReport = '/finance/daily-sales-report/get-url'



// WEBPACK FOOTER //
// ./src/api/url/finance.js